import {
	CheckboxGroup,
	CheckboxGroupItem,
	RadioButtonGroup,
	RadioButtonGroupItem,
	ValidationError
} from "client/Components";
import { NoUniqueInputIdContext } from "client/Contexts/UniqueInputIdContext";
import { IValueInputAttachable } from "client/Forms/attachable";
import { createValidationConfiguration, IValidationConfiguration } from "client/Validation";
import { hasMinimumEntries } from "client/Validation/rules";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { Browser } from "client/Api/common";

export type BrowsersValue = {
	restrictBrowsers: boolean;
	browsers: readonly Browser[];
};

export type BrowsersProps = {
	attachable: IValueInputAttachable<BrowsersValue>;
};

export const Browsers = (props: BrowsersProps): ReactElement => {
	const {
		attachable
	} = props;

	return (
		<div>
			<NoUniqueInputIdContext>
				<RadioButtonGroup
					{...attachable.for("restrictBrowsers").attachToRadioButtonGroup()}
					options={restrictBrowserOptions}
				/>

				{attachable.for("restrictBrowsers").value && (
					<>
						<CheckboxGroup
							{...attachable.for("browsers").attachToCheckboxGroup()}
							options={browserOptions}
						/>
						<ValidationError {...attachable.for("browsers").attachToValidationError()} />
					</>
				)}
			</NoUniqueInputIdContext>
		</div>
	);
};
Browsers.displayName = "Browsers";

const restrictBrowserOptions: readonly RadioButtonGroupItem<boolean>[] = [
	{
		text: localize("_AllBrowsers"),
		value: false
	},
	{
		text: localize("_SelectBrowsers"),
		value: true
	}
];

const browserOptions: readonly CheckboxGroupItem<Browser>[] = [
	{
		text: localize("_GoogleChrome"),
		value: Browser.Chrome
	},
	{
		text: localize("_InternetExplorer"),
		value: Browser.InternetExplorer
	},
	{
		text: localize("_MozillaFirefox"),
		value: Browser.Firefox
	},
	{
		text: localize("_AppleSafari"),
		value: Browser.Safari
	},
	{
		text: localize("_MicrosoftEdge"),
		value: Browser.Edge
	},
	{
		text: localize("_Opera"),
		value: Browser.Opera
	}
];

export function createBrowsersValidation<TModel extends BrowsersValue>(): IValidationConfiguration<TModel> {
	const result: IValidationConfiguration<TModel> = createValidationConfiguration<TModel>();

	const conditionalValidator: IValidationConfiguration<TModel> = result.when(x => x.restrictBrowsers);

	const browsersValidator = conditionalValidator.forCollection("browsers");

	browsersValidator.add(
		hasMinimumEntries(
			1,
			localize("_AtLeastOneBrowser")
		)
	);

	return result;
}